var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"docScroll mt-6",attrs:{"id":"recurring_functionality"}},[_c('SectionColumn',{attrs:{"type":"full","title":"Additional methods of integrating Recurring Billing","content":_vm.contentCol}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }